import React from 'react';
import ReactPhoneInput from 'react-phone-number-input';
import { CustomAntCountrySelect } from 'components/common/phoneInput/CustomAntCountrySelect';
import 'components/common/phoneInput/phone_input_costomization.scss';
import 'react-phone-number-input/style.css';

type PhoneInputProps = Omit<React.ComponentProps<typeof ReactPhoneInput>, 'onChange'>;

export const PhoneInput: React.FC<PhoneInputProps> = (props) => {
  return (
    <ReactPhoneInput
      className="custom-phone-input"
      countrySelectComponent={CustomAntCountrySelect}
      onChange={() => {}} // Empty function to bypass handling
      {...props}
    />
  );
};
